var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[(_vm.preload)?_c('div',{staticClass:"carregando"},[_c('div',[_c('img',{staticClass:"logo-loading",attrs:{"src":require("@/assets/img/_logo.svg"),"alt":"logo-loading"}}),_c('span',{staticClass:"loading-carregando"})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }